module.exports={CapabilitiesAffected:"受影響的功能:",ShowRelated:"顯示 {relatedCount} 個相關項目"};